export default __webpack_public_path__ + "static/media/atatürk10.cbce975b.gif";